export const OTP_CONFIG = {
  length: 6,
  expirationTimeMinutes: 10,
} as const;
